import {kActiveExercisers} from "../../../constants/exercisers";
import {get_nested} from "../../../services/JsonHandler";
import {isNullOrUndefined} from "../../../services/Validator";
import ExerciserResultsScreen from "./ExerciserResultsScreen";
import SystemFullScreenError from "../../../components/errors/SystemFullScreenError";
import SystemLeaveFlashDialog from "../../../components/dialogs/SystemLeaveFlashDialog";
import ExerciserTopBar from "../../../components/bars/courses/exercisers/ExerciserTopBar";
import SystemExistingFlashSnackBar from "../../../components/snackbars/SystemExistingFlashSnackBar";
import ExerciserContentMetaLayout from "../../../components/layouts/courses/exercisers/ExerciserContentMetaLayout";
import ExerciserContentLayout from "../../../components/layouts/courses/exercisers/ExerciserContentLayout";

export default function MetaExerciserScreen({ isLeaveModalOpen,
                                              setIsLeaveModalOpen,
                                              onLeaveExerciserPressed,
                                              leaveSessionCallback,
                                              levelAIdentifier,
                                              problem,
                                              currentIndex,
                                              setCurrentIndex,
                                              isExerciserOver,
                                              setIsExerciserOver,
                                              isSnackbarOpen,
                                              handleClose }) {
    // Used in MetaCoursesScreen to manage exerciser
    // related content and screens

    // PROPERTIES
    const activeExerciser = kActiveExercisers.find(
        (ex) => ex.id === Number(levelAIdentifier)
    );
    const totalQuestions = get_nested(['questions'], problem, []).length


    // BUILD
    if (isNullOrUndefined(activeExerciser))
        return <SystemFullScreenError />
    if (isExerciserOver)
        return <ExerciserResultsScreen isLeaveModalOpen={isLeaveModalOpen}
                                       setIsLeaveModalOpen={setIsLeaveModalOpen}
                                       onLeaveExerciserPressed={onLeaveExerciserPressed}
                                       leaveExerciser={leaveSessionCallback}
                                       problem={problem}
                                       isSnackbarOpen={isSnackbarOpen}
                                       handleClose={handleClose} />
    const Component = activeExerciser.component
    return (
        <div className="overflow-auto animate-appear w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** ---- MODAL */}
            <SystemLeaveFlashDialog open={isLeaveModalOpen}
                                    handleClose={() => setIsLeaveModalOpen(false)}
                                    leave={leaveSessionCallback} />
            {/** SNACKBAR */}
            <SystemExistingFlashSnackBar open={isSnackbarOpen}
                                         handleClose={handleClose} />
            {/** TOP BAR */}
            <ExerciserTopBar onLeaveFlashPressed={onLeaveExerciserPressed}
                             currentIndex={currentIndex}
                             total={totalQuestions} />
            {/** CONTENT */}
            <ExerciserContentMetaLayout>
                <ExerciserContentLayout>
                    <Component problem={problem}
                               setIsExerciserOver={setIsExerciserOver}
                               currentIndex={currentIndex}
                               setCurrentIndex={setCurrentIndex} />
                </ExerciserContentLayout>
            </ExerciserContentMetaLayout>
        </div>
    )
}